var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('SpinnerLoader'):_c('div',[(_vm.screen && !_vm.error)?_c('NodeScreen',{attrs:{"active-actions":false,"setting":_vm.screen}}):_c('div',[_vm._v(" Не передан id экрана ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }